import { IEvaluationAggregateQueryModel } from './evaluationAggregateQueryModel';
import _ from 'lodash';
import { AttributeUiType } from '../attributes/attributeUiType';

export class PersonEvaluationOverview {
  static parse(data: IEvaluationAggregateQueryModel[]) {
    let uniqQuestions: IPersonEvaluationQuestionOverview[] = [];
    if (data && data.length > 0) {
      uniqQuestions = []
        .concat(
          ..._.uniqBy(
            data.map((x) => {
              return {
                questionId: x.questionId,
                questionName: x.questionName,
                questionType: x.questionType,
                isEnumeratedType:
                  x.questionType == AttributeUiType.Checkboxes ||
                  x.questionType == AttributeUiType.DropDown ||
                  x.questionType == AttributeUiType.MultiSelect
              };
            }),
            'questionId'
          )
        )
        .map((question) => {
          if (question.isEnumeratedType) {
            question.aggregateValue = data
              .filter((x) => x.questionId == question.questionId)
              .map((x) => {
                return {
                  questionItemName: x.questionItemName,
                  answer: Number.parseFloat(x.aggregateResponseValue) * 100
                };
              });
          } else if (question.questionType == AttributeUiType.StarRating) {
            question.aggregateValue = data
              .filter((x) => x.questionId == question.questionId)
              .map((x) => Number.parseFloat(x.aggregateResponseValue))[0];
          } else {
            // TODO: aggregateResponseValue is null for question types EvaluationAggregateView
            // doesn't compute (notably RadioButtonGroup, which the frontend treats as enumerated
            // but the SQL view excludes from its option-count branch). Update the view to include
            // UIType 7 alongside 6/8/9, then this null-guard can go away.
            question.aggregateValue = data
              .filter((x) => x.questionId == question.questionId)
              .map((x) => {
                return {
                  answer: x.aggregateResponseValue?.split('|*|') ?? [],
                  teamName: x.teamName
                };
              });
          }
          return question;
        });
    }

    return uniqQuestions;
  }
}

export interface IPersonEvaluationQuestionOverview {
  questionId: string;
  questionName: string;
  questionType: AttributeUiType;
  isEnumeratedType: boolean;
  aggregateValue: IPersonEvaluationAnswerOverview[] | any;
}

export interface IPersonEvaluationAnswerOverview {
  questionItemName: string;
  teamName: string;
  answer: any;
}
